import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useSearchActions } from '#src/app/pages/search/shared/searchState';

type Result = ModelHookResult<
	undefined,
	{
		filterByVictories: () => void;
	}
>;

export function useFilterByVictories(): Result {
	const actions = useSearchActions();
	const track = useTracking();

	return {
		actions: {
			filterByVictories: useCallback(() => {
				void track('search', { q: '', context: 'landing_victories_button' });
				actions.setStatus('victory');
			}, [actions, track]),
		},
	};
}
